import * as React from 'react'
import Layout from 'src/components/layout'
import { graphql } from 'gatsby'
import HeroSection from 'src/components/sections/hero'
import ContactSection from 'src/components/sections/ContactSection'
import { Link } from 'gatsby-plugin-react-i18next'
import ButtonIcon, { ButtonSizes } from 'src/components/ui/ButtonIcon'

import { getPageContent } from 'src/helpers/pageContent'

const IndexPage = ({ data, pageContext }: any) => {
  const language = pageContext?.language || 'en'
  const translation = data?.directus?.pages?.[0]?.translations?.[0]
  const cmsJson = getPageContent('/accessibility-statement', language, translation?.content)

  if (!cmsJson || Object.keys(cmsJson).length === 0) {
    return <h1>Missing translation</h1>
  }

  // Transform content to use H4 for headers within paragraphs
  const formattedContent = cmsJson.mainSection.content
    .replace('<h2>Please Contact Us</h2>', '<h4>Please Contact Us</h4>')
    .replace('<br/><br/>Contact Information:', '<h4>Contact Information:</h4>')

  return (
    <Layout title={cmsJson.title} metas={cmsJson.metas} isBottomMenuHidden={true}>
      <HeroSection
        translationContent={{
          subtitle: '',
          firstPartOfTitle: cmsJson.mainSection.firstPartOfTitle,
          secondPartOfTitle: cmsJson.mainSection.secondPartOfTitle,
          content: formattedContent,
          ctaLink: '',
          ctaText: '',
          sectionName: 'accessibility-hero',
        }}
        isFullHeight={false}
        useFormattedHtml={true}
        contentClassName="mt-6 md:mt-10"
        sectionClassName="mt-16 md:mt-colossal"
        beforeTitleContent={
          <Link to="/" className="hidden md:inline-block">
            <ButtonIcon
              size={ButtonSizes.large}
              morphingIcon="arrow-to-x"
            />
          </Link>
        }
        isH2={true}
      />
      <ContactSection />
    </Layout>
  )
}

export const query = graphql`
  query ($language: String!) {
    locales: allLocale(filter: { language: { eq: $language } }) {
      edges {
        node {
          ns
          data
          language
        }
      }
    }
    directus {
      pages(filter: { slug: { _eq: "/accessibility-statement" } }) {
        translations(filter: { languages_code: { code: { _eq: $language } } }) {
          content
        }
      }
    }
  }
`

export default IndexPage
